import React, { useEffect, useState, useCallback } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import {
  addtowishinMergerbyid,
  FilterMergerListings,
  getMergerById,
  interestedinMerger,
} from "../../../../../redux/mergers/action";
import { useDispatch, useSelector } from "react-redux";
import downloadFiles from "../../../../Common/FilesRelevent/DownloadFiles";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import useChatNavigation from "../../../../Common/useChatNavigation";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";
import PDFIcon from "../../../../Common/FilesRelevent/pdf.png";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import DisplayFileExtensionWise from "../../../../Common/FilesRelevent/DisplayFileExtensionWise";
import Access from "../../../../CustomComponents/Access/Access";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";

export default function MergersAcquisitionDetails({
  setModalOpen,
  bxpData,
  showbutton = true,
  showintersted = false,
  needtohitapi = true,
}) {
  const { setOTSroute } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const token = localStorage.getItem("urexperttoken");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const { state } = useAllFilterBaseContext();
  const { pageNumber } = state;

  const { letChat } = useChatNavigation();

  const handleImageError = (e) => {
    e.target.src = `${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-1.png`;
  };

  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // Get merger data from Redux store
  const merger = useSelector(({ mergers: { getmergersbyid } }) => getmergersbyid);

  // Fetch merger data when bxpData changes
  useEffect(() => {
    if (bxpData?.id) {
      dispatch(getMergerById(bxpData?.id));
    }
  }, [bxpData, dispatch]);

  const data = {
    method: "GET",
    index: pageNumber,
    search: state?.search,
    size: 15,
    proposed: state.proposed,
    viewed: state.viewed,
    wishlist: state.wishlist,
    filter: [
      {
        id: "45",
        title: "Country",
        values: state?.countries,
      },
      {
        id: "47",
        title: "Search Mergers",
        value: state?.search,
      },
      {
        id: "46",
        title: "sort by",
        values: state?.sortByTime,
      },
      {
        id: "44",
        title: "Industry",
        filter_type: "5",
        values: state?.industries,
      },
    ],
  };

  const handllGetAllData = useCallback(() => {
    dispatch(FilterMergerListings(data));
  }, [dispatch, data]);

  const addtowishlist11 = useCallback((id) => {
    if (token) {
      dispatch(addtowishinMergerbyid(id, handllGetAllData, navigate));
    } else {
      navigate(`/${laung}/loginwithemail`);
    }
  }, [token, dispatch, handllGetAllData, navigate, laung]);

  const handleNavigateToOTS = useCallback((id) => {
    navigate(`/${lan}/dashboard/myotsproducts?mergerid=${id}`);
    setOTSroute("MergersAcquisitions");
  }, [navigate, lan, setOTSroute]);

  // Fixed interest function - uses current merger data directly
  const interstedinMerger = useCallback(async () => {
    if (!token) {
      navigate(`/${laung}/loginwithemail`);
      return;
    }
    navigate(`/${lan}/mergersacquisitionscontract/${merger?.id}`, { state: { owner: true } });

    // if (merger?.id) {
    //   setLoading(true);
    //   try {
    //     await dispatch(interestedinMerger(merger.id, navigate));
    //     setModalOpen(false);
    //   } catch (error) {
    //     console.error("Error expressing interest:", error);
    //   } finally {
    //     setLoading(false);
    //     setModalOpen(false);
    //   }
    // }
  }, [merger?.id, token, dispatch, navigate, laung, setModalOpen]);

  const handleInterestClick = useCallback(() => {
    setModal(true);
  }, []);

  // Don't render until we have merger data
  if (!merger) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {
        modal &&
        <Access
          modal={modal}
          setModal={setModal}
          page="propose_mergers"
          checkpermission="propose_mergers"
          hitmethod={needtohitapi ? "" : interstedinMerger}
          masterID={merger?.id}
          loading={loading}
          checkrole={false}
        />
      }
      <div className="merger-modal">
        {showintersted &&
          Array.isArray(merger?.proposal) &&
          merger.proposal.map((od, indi) => {
            return (
              <div
                key={indi}
                style={{
                  background: "#fff",
                  border: "2px solid black",
                  borderRadius: 25,
                  padding: 20,
                }}
              >
                <div className="item-details buyer-info">
                  <h5>Merger/Acquisition request </h5>
                  <div className="professional ">
                    <ProfileImageWithFallback url={od?.profile_image} style={{ width: 40, height: 40, borderRadius: 50 }} />
                    <div className="professional-left">
                      <div > 
                        <h6>
                          {od?.first_name} {od?.last_name}
                        </h6>
                        <p className="location">
                          {" "}
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                            alt=""
                          />{" "}
                          {od?.country_title}{" "}
                        </p>
                      </div>
                      <div>
                        <p className="pb-1">{od?.email_id} </p>
                        <p>
                          {od?.country_code ? od?.country_code : ""}{" "}
                          {od?.mobile_number}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <button
                    className="buttons border-button "
                    onClick={() => {
                      letChat(od);
                    }}
                  >
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                      alt=""
                    />{" "}
                    Chat
                  </button>
                </div>
              </div>
            );
          })}
        <div className="merger-img">
          <ProfileImageWithFallback url={merger?.logo} style={{ objectFit: 'contain', width: '200px', borderRadius: 0 }} />
          <div>
            <h3>{merger?.company_name}</h3>
          </div>
        </div>
        <div>
          <p>Website</p>
          <h5>
            <a
              href={
                merger?.website_link?.startsWith("http")
                  ? merger?.website_link
                  : `https://${merger?.website_link}`
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue", textDecoration: "none" }}
            >
              {merger?.website_link}
            </a>
          </h5>
        </div>
        <div>
          <p>Industry</p>
          <h5>{merger?.industry_title}</h5>
        </div>
        <div>
          <p>Location</p>
          <h5>{merger?.address} </h5>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <p>City</p>
            <h5>{merger?.city}</h5>
          </div>
          <div>
            <p>Country</p>
            <h5>{merger?.country_title}</h5>
          </div>
          <div>
            <p>Pincode</p>
            <h5>{merger?.pincode}</h5>
          </div>
        </div>
        <div>
          <p>Company description</p>
          <CustomReactQuillDescription value={merger.description} />
        </div>
        <div>
          <p>Company profile</p>
          <div className="company-profile justify-content-start merger-company-profile">
            {merger &&
              Array.isArray(merger.files) &&
              merger.files.map((merg_file, indi) => {
                return (
                  <div key={indi} className="company-left">
                    <DisplayFileExtensionWise
                      item={merg_file}
                      alt=""
                    />
                    <button className="company-profile-button">
                      <img
                        onClick={() => downloadFiles(merg_file?.file)}
                        src={`${CloudStorage.cloudurl}/Assets/Images/common/download-icon-black.png`}
                        alt=""
                      />
                    </button>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      {showbutton && (
        <div
          className="d-flex align-items-center"
          style={{ columnGap: "15px" }}
        >
          {merger?.is_mine == 0 ? (
            <button
              className="buttons background-button w-100"
              onClick={handleInterestClick}
              disabled={loading || merger?.request_sent == 1}
            >
              {merger?.request_sent == 1
                ? "Request sent"
                : loading
                  ? "Processing..."
                  : "I'm Interested"}
            </button>
          ) : (
            <button
              className="buttons background-button w-100"
              onClick={() => handleNavigateToOTS(merger.id)}
            >
              View details
            </button>
          )}
          <button
            className="btn heart-btn"
            style={{ background: "transparent", padding: "0" }}
            onClick={() => {
              addtowishlist11(merger?.id);
            }}
          >
            {merger?.wishlist == 1 ? (
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                alt=""
              />
            ) : (
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                alt=""
              />
            )}
          </button>
        </div>
      )}
    </>
  );
}